<template>
    <div
        class="app clearfix"
        style="width:100%"
    >
        <h-top></h-top>
        <div class="app">
            <div class="left-pic">
                <img src="../../assets/image/img/NewRegister/zc_left.png">
            </div>
            <div class="register-right">
                <div
                    class="logo"
                    @click="jumpIndex"
                ></div>
                <div class="register-box">
                    <!-- 表单注册 ----------------------------------------------------------------------->
                    <div v-if="div_type == 0">
                        <div class="reg-box">
                            <p
                                class="register_title"
                                v-show="radio_type == 1 || radio_type == ''"
                            >注册</p>
                            <p
                                class="register_title"
                                v-show="radio_type == 2"
                            >会员注册</p>
                            <div
                                class="register-chose clearfix"
                                style="margin:20px 0 20px 0;height:30px"
                            >
                                <input
                                    class="radio_type"
                                    type="radio"
                                    name="type"
                                    @click="radioTypeClick(1)"
                                />
                                <!--checked="checked"-->
                                <label>普通用户注册</label>
                                <input
                                    class="radio_type"
                                    type="radio"
                                    name="type"
                                    @click="radioTypeClick(2)"
                                />
                                <label>会员用户注册</label>
                            </div>

                            <div class="register-item-mobile">
                                <input
                                    type="tel"
                                    placeholder="请输入手机号"
                                    v-model="usertel"
                                    oninput="if(value.length>11)value=value.slice(0,11)"
                                />
                            </div>
                            <div class="register-item-code clearfix">
                                <input
                                    type="text"
                                    placeholder="请输验证码"
                                    v-model="vcode"
                                    oninput="if(value.length>6)value=value.slice(0,6)"
                                />
                                <div
                                    class="send-btn"
                                    @click="sendcode"
                                    v-show="codeflag"
                                >
                                    发送验证码
                                </div>
                                <div
                                    class="send-btn"
                                    v-show="!codeflag"
                                >
                                    {{count}}秒后重发
                                </div>
                            </div>
                            <select
                                class="select-css"
                                name=""
                                id=""
                                @change="test"
                                v-model="current"
                                placeholder="请选择性别"
                            >
                                <option
                                    v-for="(item,index) in list"
                                    :key="index"
                                    :value="item.id"
                                    :data-rid='item.rid'
                                >{{item.name}}</option>
                            </select>
                            <div class="register-item-pwd">
                                <input
                                    type="password"
                                    placeholder="请输入8位密码,字母/数字"
                                    v-model="password"
                                />
                            </div>
                            <div class="register-item-pwd">
                                <input
                                    type="password"
                                    placeholder="请再次输入密码"
                                    v-model="Qpassword"
                                />
                            </div>
                            <div class="register-agreement clearfix">
                                <input
                                    type="checkbox"
                                    class="checkbox_type"
                                    v-model="checkbox_type"
                                />
                                <p>我已认真阅读并接受厨房网<a href="#">用户隐私协议</a></p>
                            </div>
                        </div>
                        <div
                            class="register-btn"
                            v-if="radio_type != 2"
                            @click="regist()"
                        >注册</div>
                        <div
                            class="register-btn"
                            v-else
                            @click="regist()"
                        >下一步</div>
                    </div>
                    <!-- 添加个人信息 ----------------------------------------------------------------------->
                    <div v-else-if="div_type == 1">
                        <div class="reg-box">
                            <p class="register_title" v-if="!divType">会员注册</p>
                            <p class="register_title" v-else >完善信息</p>
                            <p>添加您的个人信息</p>
                            <div style="margin-top: 3rem"></div>
                            <div
                                class="register-item-mobile"
                                style="margin: 1rem 0 0 0"
                            >
                                <input
                                    type="text"
                                    placeholder="请输入真实姓名"
                                    v-model="username"
                                />
                            </div>
                            <div
                                class="register-item-mobile"
                                style="margin: 1rem 0 0 0"
                            >
                                <input
                                    type="text"
                                    placeholder="请输入居民身份证"
                                    v-model="usercode"
                                    oninput="if(value.length>18)value=value.slice(0,18)"
                                />
                            </div>
                        </div>
                        <div
                            class="register-btn"
                            @click="nameCodeClick"
                            v-if="!divType"
                        >下一步</div>
                        <div
                            class="register-btn"
                            @click="nameCodeClickLogin"
                            v-else
                        >下一步</div>
                    </div>
                    <!-- 上传银行卡 ----------------------------------------------------------------------->
                    <div v-else-if="div_type == 2">
                        <div class="reg-box">
                            <p class="register_title" v-if="!divType">会员注册</p>
                            <p class="register_title" v-else>完善信息</p>
                            <p>添加银行卡/绑定持卡人本人的银行卡</p>
                            <div style="margin-top: 3rem"></div>

                            <div>
                                <el-form
                                    ref="form"
                                    :model="form"
                                    label-width="60px"
                                >
                                    <el-form-item label="持卡人">
                                        <el-input
                                            v-model="form.CardName"
                                            placeholder="请输入真实姓名"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="卡号">
                                        <el-input
                                            type="number"
                                            v-model="form.CardNo"
                                            placeholder="请输入银行卡号"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="卡类型">
                                        <el-select
                                            v-model="form.BankId"
                                            placeholder="请选择卡类型"
                                            style="width:100%"
                                        >
                                            <div
                                                v-for="(item, index) in bankListData"
                                                :key="index"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                ></el-option>
                                            </div>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="手机号">
                                        <el-input
                                            type="number"
                                            v-model="form.Phone"
                                            oninput="if(value.length>11)value=value.slice(0,11)"
                                            placeholder="银行预留手机号"
                                        ></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div
                            class="register-btn"
                            @click="bankCodeClick"
                        >下一步</div>
                    </div>
                    <!-- 会员权益 ----------------------------------------------------------------------->
                    <div v-else-if="div_type == 3">
                        <div class="reg-box">
                            <p
                                class="register_title"
                                v-if="!divType"
                            >会员注册</p>
                            <p
                                class="register_title"
                                v-else
                            >开通VIP</p>
                            <p>开通会员/会员福利</p>
                            <div class="reg-qy dis-cen">
                                <img
                                    style="width:223px;height:auto;margin:1rem 0 0 0"
                                    src="../../assets/image/img/NewRegister/shfl.png"
                                >
                                <div style="height:2rem"></div>
                                <div>优惠折扣大有积分</div>
                                <div>支付方便快捷 </div>
                            </div>
                            <div class="register-agreement clearfix">
                                <input
                                    type="checkbox"
                                    class="checkbox_type"
                                    v-model="is_member"
                                />
                                <p>开通前仔细阅读</a><a href="#">《会员服务协议》</a></p>
                            </div>
                        </div>
                        <div
                            class="register-btn"
                            @click="kaitongClick"
                        >立即开通</div>
                    </div>
                    <p
                        class="register-login"
                        v-if="!divType"
                    >已有账号，<span
                            @click="go_login"
                            style="color:#11D164;cursor:pointer;"
                        >直接登录</span>
                    </p>
                </div>
            </div>



            <!-- 年卡弹窗 ----------------------------------------------------------------------->
            <div
                class="reg-popup-bac req-popup-pos"
                v-if="is_popup"
            ></div>
            <div
                class="req-popup-pos reg-popup-wid dis-cen"
                v-if="is_popup"
                @click="closePopupClick"
            >
                <div class="reg-popup-box">
                    <img
                        @click="jumpClick"
                        style="width:100%"
                        src="../../assets/image/img/NewRegister/niaka.png"
                    />
                    <div class="reg-popup-code dis-cen">
                        <div class="dis">
                            <div
                                class="dis-cen"
                                style="width:100px;height:100px;border:1px solid #f2f2f2;margin-right:2rem"
                            ><img
                                    style="width:100%;height:auto;"
                                    src="../../assets/image/img/NewRegister/yushang2.png"
                                ></div>
                            <div class="reg-code-box">
                                <vue-qr
                                    :text="downloadData.url"
                                    :margin="0"
                                    colorDark="#000000"
                                    colorLight="#fff"
                                    :logoSrc="downloadData.icon + '?cache'"
                                    :logoScale="0.2"
                                    :size="100"
                                ></vue-qr>
                            </div>
                            <div style="margin: 1rem 0 0 2rem">
                                <div style="color:#FF4949;font-size: 1rem;">¥&nbsp;<span style="font-size: 2rem;">240</span></div>
                                <div style="color:#999999">请使用支付宝扫一扫</div>
                                <div style="color:#999999">扫描二维码付款</div>
                            </div>

                        </div>

                        <p
                            class="register-login"
                            v-if="!divType"
                        >如已支付完成，<span
                                @click="go_login"
                                style="color:#11D164"
                            >前往登录</span>
                        </p>
                        <p
                            class="register-login"
                            v-else
                        >如已支付完成，<span
                                @click="jumpIndex"
                                style="color:#11D164"
                            >前往首页</span>
                        </p>

                    </div>

                </div>
            </div>

            <!-- 通用底栏 ----------------------------->
            <user-bottom
                v-if="is_userbottom"
                :parent-name="userbottomData"
            ></user-bottom>
            <!--@childFn="userbottomPopup"-->
        </div>
    </div>



</template>

<script>
    import UserBottom from './components/userBottom'
    import vueQr from 'vue-qr'
    import hTop from '../header/h-top.vue'

    export default
    {
        components:
        {
            UserBottom,
            vueQr,
            hTop
        },
        data()
        {
            return {
                userbottomData: {},
                is_userbottom: true,
                divType: false,
                // +----------------------------------
                is_popup: false,
                div_type: 0, // 默认为0，1 身份证信息  2 银行卡信息  3 会员权益    // 正式的为 0
                checkbox_type: 0, // 0 未勾选  1 已勾选
                bankListData: [],
                list: [ { id: 1, name: '男', rid: 1 }, { id: 2, name: '女', rid: 2 } ],
                current: 1, // sex
                // +----------------------------------
                radio_type: '',
                count: 60, //验证码倒计时
                codeflag: true,
                password: "", //密码
                Qpassword: "", //确认密码
                vcode: "", //验证码
                usertel: '', //手机号
                codevalue: '', //后台获取的验证码
                sex: 1,
                // +----------------------------------
                username: '',
                usercode: '',
                // +----------------------------------
                form:
                {
                    CardName: '',
                    CardNo: '',
                    UserId: '',
                    BankId: '',
                    Phone: ''
                },
                // +----------------------------------
                is_member: '',
                downloadData:
                {
                    url: '',
                    icon: require( "../../assets/image/img/NewRegister/gsyh.png" )
                }

            }
        },
        created()
        {
            localStorage.setItem( 'userStatusHTop', 'registered' );

            let divType = localStorage.getItem( 'divType' )
            if ( divType && divType !== 'null' ) this.divType = true

            let num = this.$route.query.num;
            if ( num > 0 ) {

                // 声明
                this.$confirm( '本网站会员注册必须真实填写个人信息，如因本人失误原因导致的信息不一致，所造成的一切损失均由本人承担与本网站无关，请谨慎填写。', '声明',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                } ).then( () =>
                {
                    this.div_type = 1

                } ).catch( () =>
                {
                    this.$message(
                    {
                        type: 'info',
                        message: '已取消'
                    } );
                    this.$router.push(
                    {
                        path: '/'
                    } )

                } );

                this.div_type = num
            }
        },
        mounted()
        {
            let that = this
            document.onkeydown = () =>
            {
                let key = window.event.keyCode
                if ( key === 13 )
                {
                    that.regist()
                }
            }
        },
        methods:
        {
            jumpIndex()
            {
                this.$router.push( { path: "/" } )
            },
            radioTypeClick( val )
            {
                console.log( val )
                if ( val == 1 )
                {
                    this.radio_type = 1
                }
                else if ( val == 2 )
                {
                    this.radio_type = 2 // 会员用户注册
                }
            },
            go_login()
            {
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            sendcode()
            { //发送验证码
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                let name = ''
                if ( this.usertel == '' )
                {
                    name = '请输入手机号！';
                    this.checkTips( name, 'warning' );
                }
                else if ( !telReg.test( this.usertel ) )
                {
                    name = '手机号格式错误！';
                    this.checkTips( name, 'warning' );
                }
                else
                {
                    let params = {
                        mobile: this.usertel,
                        RegistrationType: 2,
                    }
                    this.$api.user.sendCode( params ).then( res =>
                    {
                        console.log( res )
                        if ( res.data.code === 0 )
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'success' );
                            sessionStorage.setItem( 'code', res.data.result );
                            const TIME_COUNT = 60;
                            if ( !this.timer )
                            {
                                this.count = TIME_COUNT;
                                this.codeflag = false;
                                this.timer = setInterval( () =>
                                {
                                    if ( this.count > 0 && this.count <= TIME_COUNT )
                                    {
                                        this.count--;
                                    }
                                    else
                                    {
                                        this.codeflag = true;
                                        clearInterval( this.timer );
                                        this.timer = null;
                                    }
                                }, 1000 )
                            }
                        }
                        else
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'warning' );
                        }
                    } )
                }
            },
            test( e )
            {
                let that = this
                let hh = that.list.filter( function( c, i, a )
                { //第一个参数为当前项,第二个参数为索引,第三个为原值
                    if ( c.id == that.current )
                    {
                        return c
                    }
                } )
                let dd = hh[ 0 ].rid //获取当前option的rid的值
                console.log( dd )
                that.sex = dd
            },
            regist( num )
            { //注册
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                let name = '';
                let code = sessionStorage.getItem( 'code' );

                if ( this.password == '' || this.Qpassword == '' || this.vcode == '' || this.usertel == '' )
                {
                    name = '必填项不能为空！';
                    this.checkTips( name, 'warning' );
                }
                else if ( !telReg.test( this.usertel ) )
                {
                    name = '手机号格式错误！';
                    this.checkTips( name, 'warning' );
                }
                else if ( this.radio_type == '' )
                {
                    name = '请选择注册类型'
                    this.checkTips( name, 'warning' );
                }
                else if ( this.checkbox_type == 0 )
                {
                    name = '请认真阅读隐私协议并勾选'
                    this.checkTips( name, 'warning' );
                }
                else if ( this.password != this.Qpassword )
                {
                    name = '两次输入密码不一致！';
                    this.checkTips( name, 'warning' );
                }
                else if ( this.vcode != code )
                {
                    let name = '验证码错误！';
                    this.checkTips( name, 'warning' );
                }
                else
                {
                    let params = {
                        Name: this.usertel,
                        code: this.vcode,
                        Phone: this.usertel,
                        Password: this.password,
                        RegistrationType: 2,
                        CategoryId: 0,
                        Sex: this.sex,
                        TrueName: this.username,
                        CardNo: this.usercode
                    }

                    console.log( params )

                    if ( this.radio_type == 1 )
                    {
                        this.$api.user.regist( params ).then( res =>
                        {
                            console.log( res )
                            if ( res.data.code == 0 )
                            {
                                let name = '注册成功！';
                                this.checkTips( name, 'success' );
                                this.$router.push(
                                {
                                    path: '/login'
                                } )
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    }
                    else if ( this.radio_type == 2 )
                    {
                        if ( !num )
                        {
                            // 声明
                            this.$confirm( '本网站会员注册必须真实填写个人信息，如因本人失误原因导致的信息不一致，所造成的一切损失均由本人承担与本网站无关，请谨慎填写。', '声明',
                            {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            } ).then( () =>
                            {
                                this.div_type = 1

                            } ).catch( () =>
                            {
                                this.$message(
                                {
                                    type: 'info',
                                    message: '已取消'
                                } );
                            } );
                        }
                        else
                        {
                            this.div_type = 1
                        }

                    }
                    // +---------------------------------------------
                    if ( num )
                    {
                        this.$api.user.regist( params ).then( res =>
                        {
                            console.log( res )
                            if ( res.data.code == 0 )
                            {
                                let name = '注册成功！';
                                this.checkTips( name, 'success' );

                                // 保存userId
                                let regObj = res.data.result
                                localStorage.setItem( 'regObj', JSON.stringify( regObj ) )
                                this.div_type = 2

                                // 拉取银行卡列表
                                this.$api.user.bankList().then( res =>
                                {
                                    if ( res.data.code == 0 )
                                    {
                                        let a = res.data.result
                                        let b = []
                                        let c = {}
                                        for ( let i = 0; i < a.length; i++ )
                                        {
                                            c = { label: a[ i ].bankname, value: a[ i ].id }
                                            b.push( c )
                                        }
                                        this.bankListData = b
                                    }
                                    else
                                    {
                                        let name = res.data.message;
                                        this.checkTips( name, 'warning' );
                                    }
                                } )
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    }
                }
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            // +-------------------------------------
            nameCodeClick()
            {
                if ( this.username == '' )
                {
                    this.checkTips( '请输入真实姓名', 'warning' );
                    return
                }
                else if ( this.usercode == '' )
                {
                    this.checkTips( '请输入居民身份证', 'warning' );
                    return
                }
                // 提交
                this.regist( 1 )
            },
            nameCodeClickLogin()
            {
                // 用户登录状态下开通会员信息

                if ( this.username == '' )
                {
                    this.checkTips( '请输入真实姓名', 'warning' );
                    return
                }
                else if ( this.usercode == '' )
                {
                    this.checkTips( '请输入居民身份证', 'warning' );
                    return
                }

                let params = {
                    TrueName: this.username,
                    CardNo: this.usercode
                }
                this.$api.user.changeTrueName( params ).then( res =>
                {
                    console.log( res )
                    if ( res.data.code == 0 )
                    {
                        this.checkTips( "更新成功！", 'success' );
                        this.div_type = 2
                        // 拉取银行卡列表
                        this.$api.user.bankList().then( res =>
                        {
                            if ( res.data.code == 0 )
                            {
                                let a = res.data.result
                                let b = []
                                let c = {}
                                for ( let i = 0; i < a.length; i++ )
                                {
                                    c = { label: a[ i ].bankname, value: a[ i ].id }
                                    b.push( c )
                                }
                                this.bankListData = b
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )

            },
            // +-------------------------------------
            bankCodeClick()
            {
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;

                if ( this.form.CardName == '' )
                {
                    this.checkTips( '请输入真实姓名', 'warning' );
                    return
                }
                else if ( this.form.CardNo == '' )
                {
                    this.checkTips( '请输入银行卡号', 'warning' );
                    return
                }
                else if ( this.form.BankId == '' )
                {
                    this.checkTips( '请选择卡类型', 'warning' );
                    return
                }
                else if ( this.form.Phone == '' )
                {
                    this.checkTips( '请输入银行卡预留手机号', 'warning' );
                    return
                }
                else if ( !telReg.test( this.form.Phone ) )
                {
                    this.checkTips( '手机号格式错误！', 'warning' );
                    return
                }

                if ( !localStorage.getItem( 'token' ) ) {
                    let regObj = JSON.parse( localStorage.getItem( 'regObj' ) )
                    this.form.UserId = regObj.userId
                } else {
                    let loginDataObj = JSON.parse( localStorage.getItem( 'loginData' ) )
                    this.form.UserId = loginDataObj.userId
                }
                console.log( this.form )

                // 提交
                this.$api.user.bankAdd( this.form ).then( res =>
                {
                    if ( res.data.code == 0 )
                    {
                        this.checkTips( '银行卡添加成功', 'success' );
                        this.div_type = 3
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )
            },
            kaitongClick()
            {
                if ( this.is_member == '' )
                {
                    this.checkTips( '请仔细阅读《会员服务协议》并勾选', 'warning' );
                    return
                }

                let dataObj = { price: 240 }
                if ( !this.divType )
                {
                    // 注册购买
                    let regObj = JSON.parse( localStorage.getItem( 'regObj' ) )
                    dataObj[ 'uid' ] = regObj.userId
                }
                // else
                // {
                //     // 用户登录状态下获取userId
                //     // let loginData = JSON.parse( localStorage.getItem( 'loginData' ) )
                //     dataObj.uid = '' // !!! 登录购买不用userId
                // }

                this.$api.user.BuyVip( dataObj ).then( res =>
                {
                    if ( res.data.code == 0 )
                    {
                        this.downloadData.url = res.data.result
                        console.log( this.downloadData.url )
                        this.is_popup = true
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )
            },
            closePopupClick()
            {
                this.is_popup = false
            },
            jumpClick()
            {
                // this.$router.push(
                // {
                //     path: '/login'
                // } )
            },




            // +-----------------------------
            editPopup( bol )
            {
                this.is_userbottom = bol
            },

        },
        computed:
        {

        }
    }
</script>

<style scoped="scoped">
    .app {
        width: 97.5rem;
        margin: 0 auto;
    }

    .reg-box {
        height: 24rem;
    }

    .left-pic {
        float: left;
        width: 54rem;
        margin-top: 4.2rem;
        margin-left: 4rem;
    }

    .left-pic img {
        width: 100%;
    }

    .register-right {
        /* float: right;
        margin-top: 5.375rem; */
        position: fixed;
        top: 3.375rem;
        right: 6rem;
        z-index: 3;

    }

    .logo {
        width: 12.0625rem;
        height: 3.75rem;
        margin-left: 2.125rem;
        background-image: url(../../assets/image/img/NewRegister/logo.png);
        background-repeat: no-repeat;
        background-size: cover;
    }

    .register-box {
        /* width: 30.5rem;
        height: 41.75rem; */
        width: 26.5rem;
        height: 35.59rem;
        padding-top: 3.5rem;
        padding-left: 4rem;
        padding-right: 4rem;
        background-image: url(../../assets/image/img/NewRegister/zc_bg.png);
        background-repeat: no-repeat;
        background-size: cover;
    }

    .register_title {
        font-size: 2.25rem;
        font-weight: bold;
        color: #000000;
        line-height: 1em;
        margin-bottom: 1rem;
    }

    .register-chose label {
        float: left;
        font-size: 16px;
        line-height: 1em;
        display: inline-block;
        margin-left: -120px;
        margin-right: 20px;
        color: #000000;
    }

    .register-chose label:last-child {
        margin-right: 0;
    }

    .radio_type {
        float: left;
        /* width: 150px; */
        width: 50%;
        height: 20px;
        appearance: none;
        position: relative;
        cursor: pointer;
    }

    .radio_type:before {
        content: '';
        width: 18px;
        height: 18px;
        border: 1px solid #11D164;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .radio_type:checked:before {
        content: '';
        width: 18px;
        height: 18px;
        border: 1px solid #11D164;
        background: #11D164;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .radio_type:checked:after {
        content: '';
        width: 9px;
        height: 5px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 5px;
        left: 4px;
        vertical-align: middle;
        transform: rotate(-45deg);
    }

    .register-item-mobile {
        /* margin-top: 3.125rem; */
        margin-top: 0
    }

    .register-item-mobile input {
        /* width: 22.5rem; */
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
    }

    .register-item-code {
        /* width: 22.5rem; */
        width: 100%;
        margin-top: 1rem;
    }

    .register-item-code input {
        float: left;
        width: 9.5rem;
        height: 2.3rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        border: none;
        background: #F2F4FF;
        border-radius: 8px;
    }

    .send-btn {
        float: right;
        width: 8.75rem;
        border-radius: 8px;
        font-size: 16px;
        color: #434343;
        line-height: 2.3rem;
        text-align: center;
        float: right;
        background-color: #F2F4FF;
        cursor: pointer;
    }

    .register-item-pwd {
        margin-top: 0;
    }

    .register-item-pwd input {
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
        margin: 1rem 0 0 0
    }

    .register-agreement {
        width: 22.5rem;
        margin-top: 1rem;
    }

    .checkbox_type {
        float: left;
        width: 13.125rem;
        height: 14px;
        appearance: none;
        position: relative;
        cursor: pointer;
    }

    .checkbox_type:before {
        content: '';
        width: 14px;
        height: 14px;
        border: 1px solid #11D164;
        display: inline-block;
        vertical-align: middle;
        border-radius: 3px;
    }

    .checkbox_type:checked:before {
        content: '';
        width: 14px;
        height: 14px;
        border: 1px solid #11D164;
        background: #11D164;
        display: inline-block;
        vertical-align: middle;
    }

    .checkbox_type:checked:after {
        content: '';
        width: 8px;
        height: 4px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 4px;
        left: 3px;
        vertical-align: middle;
        transform: rotate(-45deg);
    }

    .register-agreement p {
        float: left;
        color: #999999;
        font-size: 15px;
        line-height: 18px;
        margin-left: -186px;
    }

    .register-agreement a {
        color: #11D164;
        display: inline-block;
    }

    .register-btn {
        width: 100%;
        background-color: #11D164;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 2.3rem;
        text-align: center;
        border-radius: 8px;
        margin-top: 1rem;
        cursor: pointer;
        /* margin: 4rem 0 0 0 */
    }

    .register-login {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        color: #999999;
    }

    .register-login a {
        display: inline-block;
        color: #11D164;
    }

    .reg-qy {
        width: 100%;
        height: 17rem;
        /* background-color: #f1f1f1; */
        /* border-radius: 2rem; */
        /* margin: 1rem 0 */
    }

    .reg-popup-bac {
        width: 100%;
        height: 100vh;
        background-color: #000000;
        opacity: 0.8;
    }

    .req-popup-pos {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }

    .reg-popup-wid {
        width: 100%;
        height: 100vh;
    }

    .reg-popup-box {
        width: 35rem;
        height: 26.5rem;
        background-color: #ffffff;
        border-radius: 2rem;
        padding: 2rem;
        box-sizing: border-box;
    }

    .dis {
        display: flex;
        flex-wrap: wrap
    }

    .dis-cen {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }

    .reg-popup-code {
        width: 100%;
        height: 13rem;
        border: 1px solid #f1f1f1;
        margin: 1.5rem 0 0 0
    }

    .select-css {
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
        margin: 1rem 0 0 0;
    }

    .xian-left {
        width: 80px;
        height: 1px;
        margin: auto 0;
        background: linear-gradient(91deg, rgba(3, 3, 3, 0) 0%, #743808 100%);
    }

    .xian-p {
        margin: 0 1rem;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #743808;

    }

    .xian-right {
        width: 80px;
        height: 1px;
        margin: auto 0;
        background: linear-gradient(91deg, #743808 0%, rgba(0, 0, 0, 0) 100%);
    }

    input {
        outline: none;
    }
</style>